import {styled} from "@mui/material";
import {
	DateRange,
	LocalizationProvider,
	StaticDateRangePicker
} from "@mui/x-date-pickers-pro";
import {AdapterDayjs} from "@mui/x-date-pickers-pro/AdapterDayjs"

interface DateRangeCalendarProps {
	dateRange?: DateRange<Date>;
	testIdPrefix: string;
	disablePastDates?: boolean;
	onDateChange: (value: DateRange<Date>) => void;
	onShouldDisableDate: (date: Date) => boolean;
	minDate?: Date;
}

const DateRangeCalendar = ({
	dateRange,
	testIdPrefix,
	disablePastDates = false,
	onDateChange,
	onShouldDisableDate,
	minDate
}: DateRangeCalendarProps) => {

	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			<StyledDateRangeCalendar
				shouldDisableDate={onShouldDisableDate}
				onChange={onDateChange}
				data-testid={`${testIdPrefix}DatePicker`}
				calendars={1}
				value={dateRange}
				disablePast={disablePastDates}
				onAccept={onDateChange}
				disableFuture
				slotProps={{
					actionBar: {actions: []},
          	day: {["data-testid"]: `${testIdPrefix}CalendarDayButton`} as any
				}}
				minDate={minDate}
			/>
		</LocalizationProvider>
	);
};

export default DateRangeCalendar;

const StyledDateRangeCalendar = styled(StaticDateRangePicker)(({theme}) => ({
  	"&.MuiPickersLayout-root": {
    	backgroundColor: theme.palette.background.paperElevation4
  	},
  	"& .MuiDateRangePickerToolbar-root .MuiTypography-root.MuiTypography-overline":
    {
      	letterSpacing: "2px",
      	color: theme.palette.primary.main
    },
  	"& .MuiPickersToolbar-root .MuiTypography-h5, .MuiPickersToolbar-root .MuiTypography-h6":
    {
      	fontSize: theme.typography.h4.fontSize
    },
	"& .MuiButtonBase-root": {
		border: "none"
	}
}));

